import { XIcon } from "@heroicons/react/solid";
import React from "react";
import { CopyBlock, monoBlue } from "react-code-blocks";

function ViewCodeModal({ openViewCodeModal, codeData }) {
  return (
    <>
      <div className="justify-center items-center  flex  fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="w-11/12 sm:w-5/6 md:w-3/4 lg:w-2/3 xl:w-1/2 h-auto max-h-[90vh] rounded-md mx-auto my-auto">
          {/*content*/}
          <div className="rounded-lg h-full bg-white outline-none focus:outline-none flex flex-col">
            {/*header*/}

            <div className="flex justify-between w-full h-[7%] pt-2 pr-2 pl-4 ">
              <h3 className="text-primary text-2xl  font-robo ">
                Code Preview
              </h3>
              <div className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full">
                <XIcon
                  className="h-5 w-5 "
                  aria-hidden="true"
                  onClick={() => openViewCodeModal(false)}
                />
              </div>
            </div>
            {/*body*/}
            <div className="px-4 pb-4 flex-1 min-h-0">
              <div className="overflow-x-auto overflow-y-auto chat__container h-full">
                <CopyBlock
                  language={codeData.language}
                  text={codeData.script}
                  theme={monoBlue}
                  codeBlock
                  wrapLines={true}
                  showLineNumbers={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-50  fixed inset-0 z-20 bg-black"></div>
    </>
  );
}
export default ViewCodeModal;
